import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    quickAccessEdit: false
  },
  mutations: {
    SET_EDITING_STATE(state, value) {
      state.quickAccessEdit = value;
    }
  },
  actions: {
    setEditing({ commit }, newValue) {
      commit("SET_EDITING_STATE", newValue);
    }
  },
  getters: {
    editing: (state) => state.quickAccessEdit
  }
};
